/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Category_Empty_DescInputs */

const en_directory_category_empty_desc = /** @type {(inputs: Directory_Category_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're still curating tools for this section — check back soon, or submit one.`)
};

const zh_directory_category_empty_desc = /** @type {(inputs: Directory_Category_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们还在为这个板块精选工具——稍后再来看看，或者提交一个吧。`)
};

/**
* | output |
* | --- |
* | "We're still curating tools for this section — check back soon, or submit one." |
*
* @param {Directory_Category_Empty_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_category_empty_desc = /** @type {((inputs?: Directory_Category_Empty_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Category_Empty_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_category_empty_desc(inputs)
	return zh_directory_category_empty_desc(inputs)
});
export { directory_category_empty_desc as "directory.category.empty_desc" }